import ChartJS from "chart.js/auto"
import { ArcElement, Legend, Tooltip } from "chart.js"
import { useSelector } from "react-redux"
import { getConf } from "../../../store/features/confSlice"
import { useEffect, useState } from "react"
import axios from "axios"
import { Line, Pie } from "react-chartjs-2"
import moment from "moment"
import "moment/locale/es"
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material"
import saveAs from "file-saver"
import { getAuth } from "../../../store/features/authSlice"

/**
 * Tipo: Pie
 * Detalle: Muestra el total de ingresos por método de pago en el mes actual
 */

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env
ChartJS.register(ArcElement, Tooltip, Legend)

export const IncomeForPaymentMethodForDayChart = () => {
  const conf = useSelector(getConf)
  const auth = useSelector(getAuth)
  const [report, setReport] = useState([])
  const [isLoading, setLoading] = useState(true)
  const [filters, setFilters] = useState({
    period: moment().format("YYYY-MM"),
  })
  const title = "Ingresos por método de pago por mes"
  const periods = [...Array(12).keys()].map((i) =>
    moment().subtract(i, "month").format("YYYY-MM")
  )

  useEffect(() => {
    getReport()
  }, [filters])

  const getReport = async () => {
    try {
      const endpoint = `/report/chart/income-for-payment-method-for-month?period=${filters.period}`
      const { data } = await axios.get(API_ROUTE + endpoint, {
        headers: { Authorization: auth.data.jwtToken },
      })
      setReport(data)
      console.table(data)
      setLoading(false)
    } catch (err) {
      console.log(err)
      console.log("No se pudo obtener los datos del reporte")
    }
  }

  const handleChange = (e) => {
    const name = e.target.name
    const value = e.target.value

    console.log(name, value)

    switch (name) {
      case "period":
        setFilters({ ...filters, [name]: value.substring(0, 7) })
        break
      default:
        setFilters({ ...filters, [name]: value })
    }
  }

  const download = () => {
    const head = "método de pago;ingresos\n"
    const body = report
      .map((item) => {
        const method = item.method
        const income = item.income
        return method + ";" + income
      })
      .join("\n")
    const file = new Blob([head + body])
    saveAs(file, `${Date.now()}.txt`)
  }

  if (isLoading) return <></>

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      title: {
        display: true,
        text: title,
      },
    },
  }

  const data = {
    labels: report.map((item) => item.method),
    datasets: [
      {
        label: "Ingresos",
        data: report.map((item) => item.income.toFixed(2)),
        backgroundColor: conf.data.colors
          .filter((_, index) => index > 3)
          .map((item) => item.bg),
        borderWidth: 1,
      },
    ],
  }

  return (
    <>
      <Pie options={options} data={data} />
      <Grid container spacing={1} my={1}>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel>Periodo</InputLabel>
            <Select
              value={filters.period}
              label="Periodo"
              name="period"
              onChange={handleChange}
            >
              {periods.map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <Button
            fullWidth
            variant="outlined"
            size="large"
            sx={{ height: 55 }}
            onClick={download}
          >
            Descargar
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
